import React, {useContext, useEffect, useState} from "react";
import {Button} from "primereact/button";
import './Catalog.scss';
import {Product} from "@Types/Product";
import {CatalogItem} from "@Components/CatalogItem";
import {CustomDropdown} from "@Components/CustomDropdown";
import {LoadingDiv} from "@Components/LoadingDiv";
import {Filter} from "@Pages/Home/Catalog/Filter";
import { Search } from "./Catalog/Search";
import {useNavigate, useLocation} from "react-router-dom";
import {CatalogContext} from "../../Contexts/CatalogContext";
import produce from "immer";
import {PageHeaderContext} from "@Contexts/PageHeaderProvider";
import {CartContext} from "@Contexts/CartProvider";
import {useNetworkState} from "react-use";
import {SwippableModal} from "@Components/SwippableModal";
import {FirebaseContext} from "@Contexts/FirebaseContext";
import { logEvent } from "firebase/analytics";
import {useUser} from "@Hooks/firebase";

const dropdownOptions = [{
    label: "PNEUS",
    value: "EN"
}, {
    label: "ROUES NUES",
    value: "RN"
}, {
    label: "CHAMBRE À AIR",
    value: "CH"
}, {
    label: "ROUES COMPLÈTES",
    value: 'RC'
}] as const;

export type CatalogProps = Record<string, never>
export const Catalog: React.FC<CatalogProps> = () => {
    const [category, setCategory] = useState<'EN' | 'RN' | 'CH' | 'RC'>(dropdownOptions[0].value);
    const [filteredProducts, setFilteredProducts] = useState<Product[]>([]);
    const { online } = useNetworkState();
    const [filterVisible, setFilterVisible] = useState<boolean>(false);
    const [searchVisible, setSearchVisible] = useState<boolean>(false);
    const fb = useContext(FirebaseContext);
    const user = useUser(true);
    const navigate = useNavigate();
    const location = useLocation();
    const {products, isLoading, loadProducts} = useContext(CatalogContext);
    const {setHeader} = useContext(PageHeaderContext);
    const {cart} = useContext(CartContext);

    useEffect(() => {
        const params = new URLSearchParams(location.search);
        const categoryParam = params.get('category') as 'EN' | 'RN' | 'CH' | 'RC';
        if (categoryParam) {
            setCategory(categoryParam);
        }
    }, [location.search]);

    useEffect(() => {
        const params = new URLSearchParams(location.search);

        const filters: Record<string, string | undefined> = {};
        params.forEach((value, key) => {
            if (key !== 'category') {
                filters[key] = value;
            }
        });

        console.log(products);
        const filtered = products.filter(p => {
            return Object.keys(filters).every(key => {
                const fieldName = `${category === "EN" ? "PN" : category}_M_${key}`;
                const fieldNameAlternative = `${category === "EN" ? "PN" : category}_MT_${key}`;
                const fieldNameAlternative2 = `${category === "EN" ? "PN" : category}_TM_${key}`;
                // @ts-ignore
                const productValue = p.meta[fieldName] ?? p.meta[fieldNameAlternative] ?? p.meta[fieldNameAlternative2];
                return productValue === filters[key] || p.brand.trim() === filters[key] || p.type.trim() === filters[key];
            });
        });

        setFilteredProducts(filtered);

    }, [products, location.search, category]);

    useEffect(() => {
        if (!isLoading && online && products.length === 0) {
            loadProducts();
        }
    }, [isLoading, products]);

    useEffect(() => {
        setHeader(produce(prev => {
            prev.right = {
                icon: 'pi pi-shopping-cart',
                badge: cart.length > 0 ? cart.length.toString() : undefined,
                action: () => {
                    navigate("/home/cart");
                }
            }
            return prev;
        }));
    }, []);

    const handleCategoryChange = (newCategory: 'EN' | 'RN' | 'CH' | 'RC') => {
        setCategory(newCategory);
        navigate({
            pathname: location.pathname,
            search: `?category=${newCategory}`
        });
    };

    const handleFilter = (products: Product[], filters: Record<string, string | undefined>) => {
        const params = new URLSearchParams();
        Object.keys(filters).forEach(key => {
            if (filters[key]) {
                params.set(key, filters[key]!);
            }
        });

        params.set('category', category);

        navigate({
            pathname: location.pathname,
            search: params.toString()
        });
        setFilteredProducts(products);
        setFilterVisible(false);
    };

    return (
        <div className="Catalog p-4 w-full flex-1">
            <SwippableModal visible={filterVisible} onHide={() => setFilterVisible(false)}>
                <Filter category={category === "EN" ? "PN" : category} products={products} onFilter={handleFilter} />
            </SwippableModal>
            <Search visible={searchVisible} setVisible={setSearchVisible} products={products} onFilter={(reference) => {
                if (fb?.analytics && user.meta) {
                    logEvent(fb.analytics, "search_ref", {
                        reference,
                        user_id: user.meta.userUid
                    });
                }
                navigate(`/home/${reference}`);
            }}/>
            <div className="Catalog__filter flex justify-content-between">
                <CustomDropdown value={category} onChange={e => handleCategoryChange(e)} options={dropdownOptions as any} className="h-full"/>
                <Button icon={"pi pi-filter"} className={"h-full p-button-rounded"} style={{width: 44}} onClick={() => setFilterVisible(true)}/>
            </div>
            <LoadingDiv loading={isLoading && products.length === 0} className="Catalog__content overflow-auto">
                {
                    filteredProducts.map(e => <CatalogItem product={e} key={e.reference} onClick={(product) => {navigate(`/home/${product.reference}`, {
                        state: product
                    })}}/> )
                }
            </LoadingDiv>
            <div className="fps--card-variant w-full flex justify-content-center align-items-center fixed left-0 bottom-0 p-5" style={{background:"white"}}>
                <Button label="Rechercher par référence" onClick={() => setSearchVisible(true)} className="w-full"/>
            </div>
        </div>
    );
};
